export const ConfigMantenedorBhe = {
	barraBusqueda: {
		criterios: ["Nombre Emisor", "Rut Emisor", "Folio"],
		criteriosKeys: ["nombreEmisor","rutEmisorBh", "folio"],
		criterioPrincipal: "Nombre Emisor",
		filiales: [] as any[],
		datePicker: true,
		nombreCampoDatePicker: "Fecha Emisión (Desde - Hasta)",
	},
	table: {
		title: "Facturación Emitida",
		add: "Carga Documento",
		options: [
			{
				name: "Importar",
				active: true,
				class: "ft-upload",
			},
			{
				name: "Exportar",
				active: true,
				class: "ft-download",
			},
			{
				name: "Solicitar Soporte",
				active: true,
				class: "ft-shuffle",
			},
		],
	},
};
